import { useEffect, useState } from "react";
import { round } from "lodash";

export const useWindowZoomLevel = () => {
  const [zoom, setZoom] = useState(window.devicePixelRatio);

  useEffect(() => {
    const handleResize = () => setZoom(window.devicePixelRatio);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return round(zoom, 1);
};
